import React from 'react';

const WorkRow = ({ work, id, scrollY, index }) => {
  return (
    <div 
      id={id}
      className="grid-row"
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        borderBottom: '1px solid #000',
        minHeight: '280px',
        transform: `translateY(${Math.max(0, (scrollY - 400 - index * 100) * -0.02)}px)`,
        willChange: 'transform'
      }}
    >
      {/* Col 1: Image */}
      <div 
        className="image-container grid-cell"
        style={{
          borderRight: '1px solid #000',
          overflow: 'hidden',
          position: 'relative'
        }}
      >
        <img 
          src={work.image} 
          alt={work.title}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: 'block'
          }}
        />
      </div>

      {/* Col 2: Metadata */}
      <div 
        className="grid-cell"
        style={{
          borderRight: '1px solid #000',
          padding: '32px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      >
        <h3 style={{
          fontFamily: '"Alata", sans-serif',
          fontSize: '0.9rem',
          fontWeight: 400,
          marginBottom: '24px',
          letterSpacing: '0.08em',
          textTransform: 'uppercase'
        }}>
          {work.title}
        </h3>
        <dl style={{ margin: 0 }}>
          {Object.entries(work.meta).map(([key, value]) => (
            <div key={key} style={{ 
              display: 'flex',
              marginBottom: '8px',
              fontSize: '0.72rem',
              lineHeight: 1.6
            }}>
              <dt style={{
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                color: '#666',
                minWidth: '100px',
                flexShrink: 0
              }}>
                {key}
              </dt>
              <dd style={{
                color: '#000',
                margin: 0
              }}>
                {value}
              </dd>
            </div>
          ))}
        </dl>
      </div>

      {/* Col 3: Sens */}
      <div 
        className="grid-cell"
        style={{
          padding: '32px',
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <p style={{
          fontFamily: '"Alata", sans-serif',
          fontSize: '0.8rem',
          lineHeight: 1.9,
          color: '#333',
          letterSpacing: '0.02em'
        }}>
          {work.sens}
        </p>
      </div>
    </div>
  );
};

export default WorkRow;
